import { Grid, Typography } from '@mui/material';

import { planCatalogPricingNoticeStyles } from './styles';

export const PlanCatalogPricingNotice = () => (
  <Grid sx={planCatalogPricingNoticeStyles.container}>
    <Typography sx={planCatalogPricingNoticeStyles.title}>Catalog pricing only</Typography>
    <Typography sx={planCatalogPricingNoticeStyles.text}>
      PayKickstart is the source of truth for what customers are actually charged. Amount, billing
      period, and trial days here are for plan picker display and BuilderPad catalog defaults
      only—they do not change live subscription prices for existing customers.
    </Typography>
  </Grid>
);
